import posthog from 'posthog-js';

const POSTHOG_EU_HOST = 'https://eu.i.posthog.com';

/**
 * Hardcoded customer allowlist for PostHog session recording.
 * When this array has entries, only customers whose shortName matches get PostHog.
 * When empty/undefined, falls back to customer.isListOfServicesEnabled.
 */
const POSTHOG_CUSTOMER_ALLOWLIST: string[] = ['aco', 'agrob', 'alphatec', 'claytec', 'trox'].map((v) =>
    v.toLowerCase()
);

interface PostHogUser {
    id: string;
    email: string;
    customer: {
        id: string;
        name: string;
        shortName: string;
        isListOfServicesEnabled: boolean;
    };
}

const isInternalUser = (customer: PostHogUser['customer']): boolean => {
    return customer.shortName === 'workist';
};

const isCustomerEligible = (customer: PostHogUser['customer']): boolean => {
    if (isInternalUser(customer)) {
        return true;
    }

    if (POSTHOG_CUSTOMER_ALLOWLIST.length > 0) {
        return POSTHOG_CUSTOMER_ALLOWLIST.includes(customer.shortName.toLowerCase());
    }

    return customer.isListOfServicesEnabled;
};

export const initPostHog = (user: PostHogUser): void => {
    const token = process.env.VITE_PUBLIC_POSTHOG_TOKEN;

    if (!token) {
        return;
    }

    if (process.env.RUN_ENV === 'development' && !token) {
        return;
    }

    if (!isCustomerEligible(user.customer)) {
        return;
    }

    posthog.init(token, {
        api_host: POSTHOG_EU_HOST,
        autocapture: false,
        capture_pageview: false,
        persistence: 'memory',
    });

    posthog.identify(user.id, {
        email: user.email,
        customerShortName: user.customer.shortName,
        isInternalUser: isInternalUser(user.customer),
    });

    posthog.group('company', user.customer.id, {
        name: user.customer.name,
        shortName: user.customer.shortName,
    });
};
